<template>
	<footer class="app-footer">
		<p>&copy; 2022</p>
	</footer>
</template>

<style lang="sass">
.app-footer
	margin-top: auto
	color: #aaa
	text-align: center
	padding: 15px 0
</style>